import { SelectOption } from '@pulseops/common'

export const COLORS = {
  SNOW: '#fafafa',
  HOWKES_BLUE: '#d3dce6',
  ALIZARIN: '#ED1B2E',
  WHITE: '#ffff',
  ROLLING_STONE: '#70777e',
  BLACK: '#000000',
  MYSTIC: '#E5EAEF',
  BISCAY: '#1B365D'
}

export interface TextCustomI {
  textColor?: string
  alignText?: string
  fontSize?: string
  fontWeight?: string
  fontStyle?: 'italic' | 'normal' | 'oblique'
}

export enum TypeFieldEnum {
  TEXTBOX = 'TEXTBOX',
  DROPDOWN_LIST = 'DROPDOWN_LIST',
  DATE_PICKER = 'DATE_PICKER'
}

enum TypeGroupNameEnum {
  INFO_CHANGE_CLIENT = 'info_change_client',
  CHANGE_DOB = 'change_dob',
  CHANGE_GENDER = 'change_gender'
}

export type typeField = `${TypeFieldEnum}`

export type typeGroupName = `${TypeGroupNameEnum}_group`
export type typeNameField = 'selectClient' | 'dob' | 'gender' | 'isCheckChangeDOBGroup' | 'isCheckChangeGenderGroup'

export type HiddenType = 'CHECK_BOX' | 'RADIO' | 'NONE'

export type FieldsType<TN> = {
  type: typeField
  formName: TN
  required: boolean
  label: string
  options?: SelectOption[]
  placeholder: string
  popupIcon?: string
  editable: boolean
  rules?: object
}

export type GroupsViewType<GN, TN> = {
  groupName: GN
  isVisible: boolean
  fields: FieldsType<TN>[]
  typeHidden?: HiddenType
  labelGroup?: string
  isBorder?: boolean
}

export enum FILE_ERROR {
  LARGE_FILE_SIZE = 'LARGE_FILE_SIZE',
  MISSING_FILE = 'MISSING_FILE'
}

export enum STATUS {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export type FileErrorType = `${FILE_ERROR}`
export type StatusType = `${STATUS}`

export type CallBackValidateUploadFileType = {
  typeError?: FileErrorType
  message?: string
  status: StatusType
}

export enum HiddenEnum {
  CHECK_BOX = 'CHECK_BOX',
  RADIO = 'RADIO',
  NONE = 'NONE'
}
export type typeHiddenEnum = `${HiddenEnum}`

export const groupsViewsConst: GroupsViewType<typeGroupName, typeNameField>[] = [
  {
    groupName: 'info_change_client_group',
    labelGroup: '',
    isVisible: true,
    typeHidden: HiddenEnum['NONE'],
    fields: [
      {
        formName: 'selectClient',
        type: TypeFieldEnum['DROPDOWN_LIST'],
        placeholder: '-',
        label: '',
        required: true,
        editable: true,
        options: [],
        rules: {}
      }
    ]
  },
  {
    groupName: 'change_dob_group',
    isVisible: true,
    typeHidden: HiddenEnum['CHECK_BOX'],
    labelGroup: '',
    isBorder: true,
    fields: [
      {
        type: TypeFieldEnum['DATE_PICKER'],
        formName: 'dob',
        label: '',
        required: true,
        editable: true,
        placeholder: '-',
        rules: {}
      }
    ]
  },
  {
    groupName: 'change_gender_group',
    isVisible: true,
    typeHidden: HiddenEnum['CHECK_BOX'],
    labelGroup: '',
    isBorder: true,
    fields: [
      {
        type: TypeFieldEnum['DROPDOWN_LIST'],
        formName: 'gender',
        label: '',
        required: true,
        editable: true,
        placeholder: '-',
        options: [],
        rules: {}
      }
    ]
  }
]

export type valuesFormType = {
  key: typeNameField
  value: Date | null | SelectOption
}
